import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Dashboard from "../../components/Dashboard";
import { useHealthDataSync } from "@/hooks/useHealthDataSync";

export default function DashboardPage() {
  const { requestSync } = useHealthDataSync();
  const { pathname } = useLocation();

  useEffect(() => {
    requestSync();
  }, [pathname, requestSync]);

  return <Dashboard />;
}
